export default "__VITE_ASSET__BXIUidKU__"